import { zDateSearchParam } from '@repo/ui/dates'
import { z } from 'zod'
import { AUDIT_ACTIONS } from '@/routes/(private)/audit/-lib/audit-catalogue'

/**
 * The filters, in the URL — Azione, Organizzazione, Periodo — so a filtered
 * view of the console's own log survives being pasted into a message.
 *
 * `organizationId` carries only the id: the applied chip resolves its name
 * through `organizationDetailQueryOptions`, so this schema stays a plain
 * identifier rather than a name that could drift from the record it names.
 *
 * The two dates are calendar days, widened to the day's edges at the point
 * they become a request — `dateToStartOfDayIso`/`dateToEndOfDayIso` at the
 * call site, same as the client's own audit page. `zDateSearchParam` already
 * catches a malformed one back to `undefined`, so a mangled link opens the
 * unfiltered list instead of an error page.
 */
export const auditSearchSchema = z.object({
	actions: z.array(z.enum(AUDIT_ACTIONS)).optional(),
	organizationId: z.string().optional(),
	from: zDateSearchParam,
	to: zDateSearchParam
})

/**
 * Whether anything is narrowing the list — read by the filter row, which
 * shows a "clear everything" only when there is something to clear, and by
 * the empty state, which decides between "these filters matched nothing" and
 * "the console has done nothing yet". One predicate for both, so the two
 * cannot drift the first time a filter is added.
 */
export function isAuditFiltered(params: z.infer<typeof auditSearchSchema>) {
	return (
		params.from !== undefined ||
		params.to !== undefined ||
		params.organizationId !== undefined ||
		(params.actions !== undefined && params.actions.length > 0)
	)
}
